<template>
    <edit-resource
        :title="title"
        :form="form"
        @close="$emit('close')"
        @submit="saveChannel"
    >

        <div class="w-600">
            <simple-input class="mb-16" v-model="form.name">
                {{ $t('settings.jobchannels.label_name') }}
            </simple-input>
            <select-dropdown class="mb-16" v-model="form.type" :options="types">
                {{ $t('settings.jobchannels.label_type') }}
            </select-dropdown>
            <select-dropdown v-model="form.url_type" :options="urlTypes">
                {{ $t('settings.jobchannels.label_url_type') }}
            </select-dropdown>
        </div>

    </edit-resource>
</template>

<script>
import EditResource from './EditResource.vue';
import Input from '../forms/Input.vue';
import Form from '../../etc/forms/Form';
import * as jobchannels from '../../services/JobChannelService';
import { normalizeJson } from '../../../shared/helpers';
import JobChannel from '../../models/JobChannel';
import SelectDropdown from '../forms/SelectDropdown';
import {mapState} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useJobChannelsStore} from '../../state/modules/job_channels';

function getFields () {
    return [
        { name: 'name', value: null},
        { name: 'type', value: 'other'},
        { name: 'url_type', value: 'detail'},
    ];
}

export default {
    components: {
        SelectDropdown,
        'edit-resource': EditResource,
        'simple-input': Input,
    },
    props: {
        channel: Object,
    },
    data: function () {
        return {
            form: this.generateForm(),
        }
    },
    computed: {
        ...mapState(useJobChannelsStore, ['types', 'urlTypes']),
        title () {
            return this.$t(this.channel ? 'general.edit_subject' : 'general.add_subject', { subject: this.$t('settings.jobchannels.single') })
        }
    },
    methods: {
        generateForm () {
            let fields = getFields();
            if (this.channel) {
                fields.forEach((field, index) => {
                    fields[index].value = JSON.parse(JSON.stringify(this.channel[field.name]));
                });
            }
            return new Form(fields);
        },
        async saveChannel () {
            if (this.channel && this.channel.id) {
                await this.updateChannel();
            } else {
                await this.createChannel();
            }

            this.$emit('close');
        },
        updateChannel () {
            return this.form.submit(data => jobchannels.update(this.channel.id, {
                data: { attributes: data },
            })).then(result => {
                return useRepo(JobChannel).save(normalizeJson(result));
            });
        },
        createChannel () {
            return this.form.submit(data => jobchannels.store({
                data: { attributes: {
                    ...data
                } },
            })).then(result => {
                return useRepo(JobChannel).save(normalizeJson(result));
            });
        },
    }
}
</script>
